import styled from 'styled-components';

import colors from 'styles/colors';

export type PolicyResultVariant = 'success' | 'analysis' | 'error';

type Theme = typeof colors;

const variantColor = (theme: Theme, variant: PolicyResultVariant): string =>
  ({
    success: theme.$success,
    analysis: theme.$warning,
    error: theme.$danger,
  }[variant]);

interface ContainerProps {
  variant: PolicyResultVariant;
}

export const Container = styled.div<ContainerProps>`
  font-family: 'Roboto', sans-serif;

  .back-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 40px;
    font-size: 14px;
    font-weight: 400;
    color: ${(props) => props.theme.$primary};

    i {
      width: 16px;
      font-size: 20px;
    }
  }

  .result-card {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
    max-width: 1200px;
    padding: 72px 24px;
    margin: 0 auto 20px;
    background-color: ${(props) => props.theme.$white};
    border-top: 6px solid ${(props) => variantColor(props.theme, props.variant)};
    border-radius: 8px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);

    @media (max-width: 767.98px) {
      flex-direction: column;
      padding: 40px 24px;
      text-align: center;
    }
  }

  .result-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 104px;
    height: 104px;

    i {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      font-size: 56px;
      color: ${(props) => variantColor(props.theme, props.variant)};
      border: 4px solid ${(props) => variantColor(props.theme, props.variant)};
      border-radius: 50%;
    }
  }

  .result-content {
    max-width: 560px;
  }

  .result-title {
    margin-bottom: 16px;
    font-size: 36px;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.36px;
    color: ${(props) => props.theme.$dark};
  }

  .result-text {
    margin-bottom: 0;
    font-size: 16px;
    line-height: 1.2;
    color: #000;

    a {
      color: ${(props) => props.theme.$primary};
    }
  }
`;
